import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollFetchEmployeesGraphQLRequest, PayrollFetchEmployeesResponse } from '../types';

const payrollFetchEmployeesQuery = gql`
  query PayrollFetchEmployees($input: FetchEmployeesInput!) {
    payrollFetchEmployees(input: $input) {
      code
      success
      message
      data {
        page
        pageSize
        total
        users {
          id
          name
          email
          designation
          department
          employeeId
        }
      }
    }
  }
`;

export const getPeopleList = (input: PayrollFetchEmployeesGraphQLRequest['input']) => {
  return graphQLApi<PayrollFetchEmployeesResponse, PayrollFetchEmployeesGraphQLRequest>({
    query: payrollFetchEmployeesQuery,
    queryVariables: { input },
  });
};
